import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CircularKPI = ({
  value,
  total,
  color = "#1C74D0",
  label = "TOTAL TALKTIME",
  title,
  percentText
}) => {

  const percentage = (value / total) * 100;

  console.log(percentage,percentText, "percentText");
  

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 220
    },

    title: null,
    credits: { enabled: false },
    tooltip: { enabled: false },

    plotOptions: {
      pie: {
        startAngle: -210,
        endAngle: 30,
        innerSize: "88%",
        size: "100%",
        borderWidth: 0,
        dataLabels: { enabled: false }
      }
    },

    series: [
      {
        data: [
          {
            y: percentage,
            color: color,
            borderRadius: 50
          },
          {
            y: 100 - percentage,
            color: "#E9EEF5"
          }
        ]
      }
    ]
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ position: "relative", width: 200, margin: "0 auto" }}>
        <HighchartsReact highcharts={Highcharts} options={options} />

        {/* Center circle */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 130,
            height: 130,
            borderRadius: "50%",
            background: "#F8FAFC",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div style={{ fontSize: 22, fontWeight: 600 }}>
            {value}
          </div>
          <div style={{ fontSize: 12, fontWeight: 500 }}>
            {title}
          </div>
          <div style={{ fontSize: 12, color: "#16A34A" }}>
            {/* ▲ 10% */}

        {/* {percentText ? <>
        ▲ {percentText}%
        </> : "0"} */}

        <span
          style={{
            color: percentText < 0 ? "red-text" : "green-txt",
            fontWeight: 500
          }}
        >
          {percentText !== null && percentText !== undefined ? (
            <>
              {percentText < 0 ? "▼" : "▲"} {Math.abs(percentText)}%
            </>
          ) : (
            "0%"
          )}
        </span>
            
          </div>
        </div>
      </div>

      <div style={{ fontWeight: 500, fontSize: 16 }}>
        {label}
      </div>
    </div>
  );
};

export default CircularKPI;